import { useEffect, useMemo, useState } from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { AsYouType, CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js'

import { MARKETS } from '~/utils/consts'

import { FormInput } from '~/components/FormInput/FormInput'

import CountrySelect from './CountrySelect'
import styles from './PhoneInput.module.css'

export function PhoneInput({
  title,
  name,
  error,
  initialCountryCode,
}: {
  title: string
  name: string
  error?: string
  initialCountryCode: MARKETS
}) {
  const {
    control,
    formState: { defaultValues = {} },
  } = useFormContext()

  const defaultValue = defaultValues[name]

  const parsedPhoneNumber = parsePhoneNumberFromString(`+${defaultValue}` || '')
  const defaultCountryCode = (parsedPhoneNumber?.country || initialCountryCode.toUpperCase()) as CountryCode
  const defaultAsYouType = useMemo(() => new AsYouType(defaultCountryCode), [defaultCountryCode])
  const defaultFormattedPhoneNumber = useMemo(() => defaultAsYouType.input(parsedPhoneNumber?.nationalNumber || ''), [defaultAsYouType])

  const [inputValue, setInputValue] = useState(defaultFormattedPhoneNumber)
  const [country, setCountry] = useState(defaultCountryCode)

  const formattedValue = new AsYouType(country).input(inputValue)

  const handleCountryChange = (country: CountryCode) => {
    setCountry(country)
  }

  useEffect(() => {
    setInputValue(defaultFormattedPhoneNumber)
  }, [defaultFormattedPhoneNumber])

  return (
    <div>
      {title && <p className={styles.label}>{title}</p>}
      <div className={styles.fieldsContainer}>
        <CountrySelect name={name} value={country} onChange={handleCountryChange} />
        <Controller
          name={name}
          control={control}
          render={({ field: { onChange, onBlur } }) => (
            <FormInput
              type='tel'
              value={formattedValue}
              errorMessage={error}
              onChange={e => {
                setInputValue(e.target.value)
                const parsedNumber = parsePhoneNumberFromString(e.target.value, country)

                onChange(parsedNumber?.number)
              }}
              onBlur={onBlur}
            />
          )}
        />
      </div>
    </div>
  )
}
